import { render, staticRenderFns } from "./RegSaas.vue?vue&type=template&id=ca4318bc&"
import script from "./RegSaas.vue?vue&type=script&lang=js&"
export * from "./RegSaas.vue?vue&type=script&lang=js&"
import style0 from "./RegSaas.vue?vue&type=style&index=0&id=ca4318bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports